<!--
 * @Description: 通知公告详情
 * @Author: PF
 * @Date: 2023-04-11 17:49:57
 * @LastEditors: PF
 * @LastEditTime: 2024-12-09 10:13:30
-->

<template>
  <div>
    <el-dialog class="wp75 hp75" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container class="xinwen">
        <el-header style="padding:20px; border: 1px solid #e4e7ed;">
          <div class="card-header">
            <h2>{{ruleForm.bt}}</h2>
            <h4 class="fu-biao-ti">
              <span>发布机构：{{ruleForm.jgmc}}</span>
              <span>发布时间：{{ruleForm.fbsj}}</span>
            </h4>
          </div>
        </el-header>
        <el-main style="padding:20px; border: 1px solid #e4e7ed; border-top: none;overflow: auto;">
          <div class="nei-rong">
            <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.nr"></p>
          </div>
        </el-main>
        <el-footer class="el-dialog__footer">
            <div class="dialog-footer">
              <div></div>
              <div class="footer_but">
                <el-button link type="primary" v-if="ruleForm.fjmc" @click="xaizai()">下载附件</el-button>
              </div>
            </div>
        </el-footer>
      </el-container>
    </el-dialog>
  </div>
</template>

<script setup>
import axios from 'axios'
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, actionPost } from '@/api/common.js'
import { download } from '@/utils/requestDownload.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/bangong/ziliaohuibian/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)

// 下载
const xaizai = async () => {
  actionPost({ url: `/api/v2/bangong/ziliaohuibian/ziliaoxiazai/${ruleForm.value.id}`, data: {} }).then((res) => {
    if (res.code === 200) {
      successPrompt(res.message)
      download(res.data, res.data.substr(res.data.lastIndexOf('/') + 1))
    } else {
      warningPrompt(res.message)
    }
  })
}

</script>
